export default "__VITE_ASSET__C6AJnW5N__"